<script lang="ts">
  import { onMount } from "svelte";
  import { getWithJwt, serverlessRoutes, translate } from "lib";
  import Spinner from "../UI/Spinner.svelte";
  import ReengageClientCard from "./ReengageClientCard.svelte";
  import type { ReengageClient } from "../../interfaces/Reengage";

  let isLoading = true;
  let hasError = false;
  let clients: ReengageClient[] = [];

  const fetchReengageClients = async (): Promise<void> => {
    isLoading = true;
    hasError = false;

    try {
      const res = await getWithJwt(serverlessRoutes.REENGAGE_CLIENTS);
      clients = Array.isArray(res?.data) ? res.data : [];
    } catch (err) {
      hasError = true;
    } finally {
      isLoading = false;
    }
  };

  onMount(fetchReengageClients);
</script>

<div class="w-full text-slate-900 dark:text-slate-100">
  <header class="px-4 pt-4 pb-3 border-b border-slate-200 dark:border-zinc-700">
    <h2 class="text-lg font-semibold">{translate("REENGAGE")}</h2>
    <p class="mt-0.5 text-xs text-slate-500 dark:text-slate-400">
      {translate("REENGAGE_SUBTITLE")}
    </p>
  </header>

  {#if isLoading}
    <Spinner height="50vh" />
  {:else if hasError}
    <div class="flex flex-col items-center justify-center text-center gap-3 py-16 px-4">
      <p class="text-sm text-slate-600 dark:text-slate-400">
        {translate("REENGAGE_ERROR")}
      </p>
      <button
        type="button"
        class="px-4 py-2 rounded-md text-sm font-medium bg-teal-600 text-white hover:bg-teal-700 transition-colors"
        on:click={fetchReengageClients}
      >
        {translate("TRY_AGAIN")}
      </button>
    </div>
  {:else if clients.length === 0}
    <div class="flex flex-col items-center justify-center text-center gap-1 py-16 px-4">
      <p class="text-sm font-medium text-slate-600 dark:text-slate-300">
        {translate("REENGAGE_EMPTY_TITLE")}
      </p>
      <p class="text-xs text-slate-500 dark:text-slate-400">
        {translate("REENGAGE_EMPTY_SUBTITLE")}
      </p>
    </div>
  {:else}
    <div class="flex flex-col">
      {#each clients as client (client.client_id)}
        <ReengageClientCard {client} />
      {/each}
    </div>
  {/if}
</div>
